import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { useFeedbacker } from '../contexts/Feedbacker'

// Checks if drawer is open and gets triggered after each route change or drawer visibility change
const useSetBackHistory: typeof useEffect = (func) => {
  const { drawerfy } = useFeedbacker()
  const location = useLocation()

  useEffect(() => {
    if (!drawerfy.isOpen) {
      func()
    }
  }, [drawerfy.isOpen, location.pathname])
}

export default useSetBackHistory
